import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Button,
  useColorModeValue,
  Alert,
  AlertIcon,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { GreshamHeader } from '../components/GreshamHeader';
import { GreshamFooter } from '../components/GreshamFooter';

const CheckoutCancel: React.FC = () => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const cardBg = useColorModeValue('white', 'gray.800');

  const handleTryAgain = () => {
    navigate('/member/subscription');
  };

  const handleGoToArticles = () => {
    navigate('/member/articles');
  };

  return (
    <Box minH="100vh" bg={bgColor}>
      <GreshamHeader />

      <Container maxW="4xl" py={12}>
        <VStack spacing={8} align="center">
          <Box
            p={8}
            bg={cardBg}
            borderRadius="xl"
            boxShadow="lg"
            w="full"
            maxW="2xl"
            textAlign="center"
          >
            <VStack spacing={6}>
              {/* Cancel Icon */}
              <Box
                w="16"
                h="16"
                bg="orange.100"
                borderRadius="full"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Text fontSize="3xl" color="orange.600">✕</Text>
              </Box>

              <Heading size="xl" color="orange.600">
                Payment Cancelled
              </Heading>

              <Text fontSize="lg" color="gray.600">
                Your payment was cancelled. No charges have been made to your account.
              </Text>

              <Alert status="info" borderRadius="lg">
                <AlertIcon />
                You can try again anytime or continue browsing our free content.
              </Alert>

              <VStack spacing={4} w="full" pt={4}>
                <Button
                  colorScheme="blue"
                  size="lg"
                  onClick={handleTryAgain}
                  w="full"
                  maxW="sm"
                >
                  Try Again
                </Button>

                <Button
                  variant="outline"
                  size="lg"
                  onClick={handleGoToArticles}
                  w="full"
                  maxW="sm"
                >
                  Browse Free Articles
                </Button>
              </VStack>
            </VStack>
          </Box>
        </VStack>
      </Container>

      <GreshamFooter />
    </Box>
  );
};

export default CheckoutCancel;